import Sparkle from './Sparkle'

export default Sparkle
// eslint-disable-next-line import/export
export * from './Sparkle'
